<script>
import http from '@/service/http'
import {mapState} from 'vuex'

export default {
  name: 'Form',
  data () {
    return {
      comoConheceu: [{}],
      cargos: [],
      cliente: {
        id: '',
        cliente: '',
        tipo: 2,
        cnpj: '',
        razao_social: '',
        ie: '',
        responsavel: '',
        cpf: '',
        rg: '',
        email: '',
        telefone: '',
        telefone2: '',
        telefone3: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        referencia: '',
        como_conheceu_id: '',
        cargo_id: '',
        obs: '',
        ativo: true,
        localizacao_imagem: '',
        localizacao_mapa: '',
        estrela: '',
        anexos: []
      },
      progress: 0,
      progress2: 0,
      progress3: 0,
      errorFile: false,
      errorFile2: false,
      errorFile3: false,
      options: {
        url: `${process.env.API_URL}/upload-image-area`,
        uploadMultiple: false,
        parallelUploads: 1,
        acceptedFiles: 'image/*',
        headers: {
          path: 'orcamentos',
          width: 800,
          height: 600,
          accept: 'all'
        }
      },
      options3: {
        url: `${process.env.API_URL}/upload-file`,
        uploadMultiple: false,
        acceptedFiles: '',
        headers: {
          path: 'clientes',
          accept: 'all'
        }
      }
    }
  },
  mounted () {
    this.fecth()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id != null) {
        this.fecth()
      }
    },
    hasAll () {
      if (this.hasAll) {
        this.all = true
      } else {
        this.all = false
      }
    }
  },
  methods: {
    setEndereco () {
      window.$.getJSON(`https://viacep.com.br/ws/${this.cliente.cep}/json/`)
      .then(response => {
        if (!response.erro) {
          this.cliente.logradouro = response.logradouro
          this.cliente.bairro = response.bairro
          this.cliente.cidade = response.localidade
          this.cliente.estado = response.uf
          $('#numero').focus()
        } else {
          this.cliente.logradouro = ''
          this.cliente.numero = ''
          this.cliente.complemento = ''
          this.cliente.bairro = ''
          this.cliente.cidade = ''
          this.cliente.estado = ''
        }
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      })
    },
    validate () {
      this.$validator.validateAll().then(success => {
        if (!success) {
          this.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          })
          return false
        } else {
          this.submit()
        }
      })
    },
    async submit () {
      const verb = this.isNew ? 'post' : 'put'
      const url = this.isNew ? '/clientes' : `/clientes/${this.cliente.id}`
      const {data} = await http[verb](url, this.cliente)
      if (data != null) {
        this.$emit('update-clientes-list', {cliente: data.cliente})
        this.$router.push({name: 'clientes.index'})
      }
    },
    async fecth () {
      this.clear()
      const {id} = this.$route.params
      if (id !== undefined) {
        const {data} = await http.get(`/clientes/${id}/edit`)
        this.cliente = data.cliente
        this.comoConheceu = data.comoConheceu
        this.cargos = data.cargos
      } else {
        const {data} = await http.get(`/clientes/create`)
        this.comoConheceu = data.comoConheceu
        this.cargos = data.cargos
      }
      setTimeout(function () {
        $('.collapsible').collapsible()
        $('.collapsible').collapsible('close', 0)
        $('.collapsible').collapsible('close', 1)
        $('.collapsible').collapsible('close', 2)
        $('.collapsible').collapsible('close', 3)
        $('.collapsible').collapsible('open', 0)
        window.Materialize.updateTextFields()
      }, 0)
    },
    clear () {
      this.cliente = {
        id: '',
        cliente: '',
        tipo: 2,
        cnpj: '',
        razao_social: '',
        ie: '',
        responsavel: '',
        cpf: '',
        rg: '',
        email: '',
        telefone: '',
        telefone2: '',
        telefone3: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        referencia: '',
        como_conheceu_id: '',
        cargo_id: '',
        obs: '',
        ativo: true,
        localizacao_imagem: '',
        localizacao_mapa: '',
        estrela: '',
        anexos: []
      }
    },
    gerarLocalizacao () {
      this.cliente.localizacao_mapa = `${this.cliente.logradouro}, ${this.cliente.numero} ${this.cliente.bairro} ${this.cliente.cidade} ${this.cliente.estado} ${this.cliente.cep}`
    },
    totalProgress (progress, totalBytes, bytesSent) {
      this.progress = progress
    },
    complete2 (file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile = true
      } else {
        this.errorFile = false
        file.addAttribute('id', xhr.response.id)
        this.cliente.localizacao_imagem = xhr.response
        this.progress = 0
      }
    },
    totalProgress3 (progress, totalBytes, bytesSent) {
      this.progress3 = progress
    },
    complete3 (files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true
      } else {
        this.errorFile = false
        this.cliente.anexos.push({anexo: xhr.response, legenda: files.name})
        this.$nextTick(() => {
          window.Materialize.updateTextFields()
        })
        this.progress = 0
      }
    },
    destroyAnexo (indexAnexo) {
      this.$swal({
        title: 'Atenção',
        text: `excluir uma anexo é uma operação irreversível`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(() => {
        if (!this.cliente.anexos[indexAnexo].id) {
          this.cliente.anexos.splice(indexAnexo, 1)
          window.Materialize.toast('Anexo excluído!', 4000)
        } else {
          http.delete(`clientes/anexo/${this.cliente.anexos[indexAnexo].id}`)
            .then(response => response.data)
            .then(data => {
              window.Materialize.toast('Anexo excluído!', 4000)
              this.cliente.anexos.splice(indexAnexo, 1)
            })
        }
      })
    }
  },
  computed: {
    ...mapState(['loading']),
    isNew () {
      return this.cliente.id === ''
    },
    api_url () {
      return process.env.UPLOADS_URL
    },
    url_app () {
      return process.env.API_URL
    }
  }
}
</script>

<template>
  <div>

    <form @submit.prevent="validate">

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <ul class="collapsible popout" data-collapsible="accordion">
            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">people</i> Informações Gerais
              </div>
              <div class="collapsible-body">

                <div class="row">
                  <div class="input-field col s12 m8">
                    <input name="cliente" id="cliente" type="text" v-validate
                           data-vv-rules="required" :class="{invalid: errors.has('cliente')}"
                           v-model="cliente.cliente">
                    <label for="cliente">*Cliente</label>
                    <small class="red-text">{{ errors.first('cliente') }}</small>
                  </div>
                  <div class="col s12 m4">
                    <label for="tipo">*Tipo</label>
                    <select name="tipo" id="tipo" v-validate data-vv-rules="required" :class="{invalid: errors.has('tipo')}" v-model.number="cliente.tipo">
                      <option value="1">Pessoa Jurídica</option>
                      <option value="2">Pessoa Física</option>
                    </select>
                    <small class="red-text">{{ errors.first('tipo') }}</small>
                  </div>
                </div>

                <div class="row" v-show="cliente.tipo === 1">
                  <div class="input-field col s12 ">
                    <input name="responsavel" id="responsavel" type="text" v-model="cliente.responsavel">
                    <label for="responsavel">Responsável</label>
                    <small class="red-text">{{ errors.first('responsavel') }}</small>
                  </div>
                </div>
                <div class="row">
                  <div class="input-field col s12 m4" v-show="cliente.tipo === 1">
                    <input name="razao_social" id="razao_social" type="text" v-model="cliente.razao_social">
                    <label for="razao_social">Razão Social</label>
                    <small class="red-text">{{ errors.first('razao_social') }}</small>
                  </div>
                  <div class="input-field col s12 m4" v-show="cliente.tipo === 1">
                    <input name="cnpj" id="cnpj" type="text" v-mask="'99.999.999/9999-99'" v-validate data-vv-rules="min:18" :class="{invalid: errors.has('cnpj')}" v-model="cliente.cnpj">
                    <label for="cnpj">CNPJ</label>
                    <small class="red-text">{{ errors.first('cnpj') }}</small>
                  </div>
                  <div class="input-field col s12 m4" v-show="cliente.tipo === 1">
                    <input name="cnpj" id="ie" type="text" :class="{invalid: errors.has('ie')}" v-model="cliente.ie">
                    <label for="ie">Inscrição Estadual</label>
                    <small class="red-text">{{ errors.first('ie') }}</small>
                  </div>
                  <div class="input-field col s12 m4" v-show="cliente.tipo === 2">
                    <input name="rg" id="rg" type="text" v-model="cliente.rg">
                    <label for="rg">RG</label>
                    <small class="red-text">{{ errors.first('rg') }}</small>
                  </div>
                  <div class="input-field col s12 m4" v-show="cliente.tipo === 2">
                    <input name="cpf" id="cpf" type="text" v-mask="'999.999.999-99'" v-validate
                           data-vv-rules="min:14" :class="{invalid: errors.has('cpf')}"
                           v-model="cliente.cpf">
                    <label for="cpf">CPF</label>
                    <small class="red-text">{{ errors.first('cpf') }}</small>
                  </div>
                  <div class="col s12 m2">
                    <label for="estrela">Estrelas</label>
                    <select name="estrela" id="estrela" v-validate data-vv-rules="required" :class="{invalid: errors.has('estrela')}" v-model.number="cliente.estrela">
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                    <small class="red-text">{{ errors.first('estrela') }}</small>
                  </div>
                  <div class="col s12 m4">
                    <label for="cargo_id">Cargo</label>
                    <select name="cargo_id" id="cargo_id" v-model="cliente.cargo_id">
                      <option v-for="cargo in cargos" :value="cargo.id">{{ cargo.cargo }}</option>
                    </select>
                    <small class="red-text">{{ errors.first('cargo_id') }}</small>
                  </div>
                </div>

              </div>
            </li>
            <li>
              <div class="collapsible-header green-text text-darken-3">
                <i class="material-icons">location_on</i>Contato / Endereço
              </div>
              <div class="collapsible-body">

                <div class="row">
                  <div class="input-field col s12 m3">
                    <input name="telefone" id="telefone" type="text" v-mask="'(99) 99999999[9]'" v-validate data-vv-rules="min:13" :class="{invalid: errors.has('telefone')}" v-model="cliente.telefone">
                    <label for="telefone">Telefone</label>
                    <small class="red-text">{{ errors.first('telefone') }}</small>
                  </div>
                  <div class="input-field col s12 m3">
                    <input name="telefone2" id="telefone2" type="text" v-mask="'(99) 99999999[9]'" v-validate data-vv-rules="min:13" :class="{invalid: errors.has('telefone2')}" v-model="cliente.telefone2">
                    <label for="telefone2">Telefone</label>
                    <small class="red-text">{{ errors.first('telefone2') }}</small>
                  </div>
                  <div class="input-field col s12 m3">
                    <input name="telefone3" id="telefone3" type="text" v-mask="'(99) 99999999[9]'" v-validate data-vv-rules="min:13" :class="{invalid: errors.has('telefone3')}" v-model="cliente.telefone3">
                    <label for="telefone3">Telefone</label>
                    <small class="red-text">{{ errors.first('telefone3') }}</small>
                  </div>
                  <div class="input-field col s12 m3">
                    <input name="email" id="email" type="text" v-validate data-vv-rules="email"
                           :class="{invalid: errors.has('email')}" v-model="cliente.email">
                    <label for="email">E-mail</label>
                    <small class="red-text">{{ errors.first('email') }}</small>
                  </div>
                </div>

                <div class="row">
                  <div class="input-field col s12 m3">
                    <input name="cep" id="cep" type="text" v-mask="'99999-999'" v-validate
                           data-vv-rules="min:9" :class="{invalid: errors.has('cep')}"
                           @blur="setEndereco" v-model="cliente.cep">
                    <label for="cep">CEP</label>
                    <small class="red-text">{{ errors.first('cep') }}</small>
                  </div>
                  <div class="input-field col s12 m5">
                    <input name="logradouro" id="logradouro" type="text"
                           v-model="cliente.logradouro">
                    <label for="logradouro">Logradouro</label>
                    <small class="red-text">{{ errors.first('logradouro') }}</small>
                  </div>
                  <div class="input-field col s12 m2">
                    <input name="numero" id="numero" type="text" v-model="cliente.numero">
                    <label for="numero">Nº</label>
                    <small class="red-text">{{ errors.first('numero') }}</small>
                  </div>
                  <div class="input-field col s12 m2">
                    <input name="complemento" id="complemento" type="text"
                           v-model="cliente.complemento">
                    <label for="complemento">Compl.</label>
                    <small class="red-text">{{ errors.first('complemento') }}</small>
                  </div>
                </div>

                <div class="row">
                  <div class="input-field col s12 m5">
                    <input name="bairro" id="bairro" type="text" v-model="cliente.bairro">
                    <label for="bairro">Bairro</label>
                    <small class="red-text">{{ errors.first('bairro') }}</small>
                  </div>
                  <div class="input-field col s12 m5">
                    <input name="cidade" id="cidade" type="text" v-model="cliente.cidade">
                    <label for="cidade">Cidade</label>
                    <small class="red-text">{{ errors.first('cidade') }}</small>
                  </div>
                  <div class="input-field col s12 m2">
                    <input name="estado" id="estado" type="text" v-model="cliente.estado">
                    <label for="estado">Estado</label>
                    <small class="red-text">{{ errors.first('estado') }}</small>
                  </div>
                </div>

                <div class="row">
                  <div class="input-field col s12">
                    <input name="referencia" id="referencia" type="text" v-model="cliente.referencia">
                    <label for="referencia">Ponto de Referência</label>
                    <small class="red-text">{{ errors.first('referencia') }}</small>
                  </div>
                </div>

                <div class="row">

                  <div class="col s12 m4">

                    <vue-clip :options="options" :on-complete="complete2" :on-total-progress="totalProgress">
                      <template slot="clip-uploader-action">
                        <div class="row">
                          <div class="col s12">
                            <div class="dz-message">
                              <div class="card">
                                <span class="card-title">Foto Localização</span>
                                <div class="center-align" style="height: 100px; width: 100%;">
                                  <img v-if="cliente.localizacao_imagem"
                                       :src="`${api_url}/orcamentos/${cliente.localizacao_imagem}`"
                                       style="max-width: 90%; max-height: 80px;">
                                  <div v-else>
                                    <img src="../../../assets/images/thumbupload.jpg"
                                         style="max-width: 90%; max-height: 50px;">
                                    <br clear="all"/>
                                    <small class="center-align">clique para inserir uma imagem</small>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="progress">
                              <div class="determinate" :style="`width: ${progress}%`"></div>
                            </div>
                            <div v-if="errorFile" class="center-align">Tipo de arquivo inválido</div>
                            <div v-if="cliente.localizacao_imagem" class="center-align"><i
                              class="material-icons pointer" @click.prevent="destroyImage()">delete_forever</i></div>
                          </div>
                        </div>
                      </template>
                    </vue-clip>

                  </div>


                  <div class="input-field col s12 m8">
                    <input name="localizacao" id="localizacao" type="text" v-model="cliente.localizacao_mapa">
                    <label for="localizacao">Mapa Localização</label>
                    <small class="red-text">{{ errors.first('localizacao_mapa') }}</small>

                    <button type="button" @click.prevent="gerarLocalizacao" class="waves-effect waves-light btn">Gerar
                      Localização
                    </button>

                  </div>
                </div>

              </div>
            </li>
            <li>
              <div class="collapsible-header green-text text-darken-3"><i class="material-icons">message</i>Informações Adicionais
              </div>
              <div class="collapsible-body">

                <div class="col s12 m4">
                  <label for="como_conheceu_id">Como Conheceu</label>
                  <select name="como_conheceu_id" id="como_conheceu_id" v-model="cliente.como_conheceu_id">
                    <option v-for="como in comoConheceu" :value="como.id">{{ como.como_conheceu }}</option>
                  </select>
                  <small class="red-text">{{ errors.first('como_conheceu_id') }}</small>
                </div>

                <div class="row">
                  <div class="input-field col s12">
                    <textarea name="obs" id="obs" class="materialize-textarea" v-model="cliente.obs"></textarea>
                    <label for="obs">Observações</label>
                    <small class="red-text">{{ errors.first('obs') }}</small>
                  </div>
                </div>

              </div>
            </li>
            <li>
              <div class="collapsible-header green-text text-darken-3"><i class="material-icons">attach_file</i>Anexos</div>
              <div class="collapsible-body">

                <div class="row">

                  <div class="col s12 m3">

                    <vue-clip :options="options3" :on-complete="complete3" :on-total-progress="totalProgress3">
                      <template slot="clip-uploader-action">
                        <div class="row">
                          <div class="col s12">
                            <div class="dz-message">
                              <div class="card center">
                                <span class="card-title">Anexo</span>
                              </div>
                            </div>
                            <div class="progress">
                              <div class="determinate" :style="`width: ${progress3}%`"></div>
                            </div>
                            <div v-if="errorFile3" class="center-align">Tipo de arquivo inválido</div>
                            <div v-if="cliente.anexo" class="center-align">
                              <i class="material-icons pointer" @click.prevent="destroyImage()">delete_forever</i>
                              <a :href="`${api_url}/clientes/${cliente.anexo}`" target="_blank"><i
                                class="material-icons pointer">search</i></a>
                            </div>
                          </div>
                        </div>
                      </template>
                    </vue-clip>

                  </div>

                </div>

                <div class="row">
                  <div class="col s12 m6 center-align" v-for="(anexo, indexAnexo) in cliente.anexos">
                    <div class="row">
                      <div class="col s12 m2">
                        <br>
                        <a :href="`${api_url}/clientes/${anexo.anexo}`" target="_blank"><i class="material-icons">file_download</i></a>
                      </div>
                      <div class="input-field col s12 m7">
                        <input name="legenda" :id="`legenda-${indexAnexo}`" type="text"
                               v-model="anexo.legenda"/>
                        <label :for="`legenda-${indexAnexo}`">Legenda</label>
                      </div>
                      <div class="col s12 m2">
                        <br>
                        <a href="#" @click.prevent="destroyAnexo(indexAnexo)">
                          <i class="material-icons red-text">delete_forever</i>
                        </a>
                      </div>
                    </div>
                    <br clear="all"/>
                  </div>
                </div>

              </div>
            </li>
          </ul>

          <div class="row">

            <div class="input-field col s12 m2">
              <input name="ativo" id="ativo" type="checkbox" v-model="cliente.ativo">
              <label for="ativo">Ativo</label>
            </div>

          </div>
          <div class="row">

            <div class="input-field col s12">
              <button class="waves-effect waves-light btn" :disabled="loading">Salvar</button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/clientes/clientes/form.vue